import { shortDateString } from 'ps-components/lib/formatters';

const css = `
  <style>
    div {
      font-family: 'Roboto', Arial, Helvetica, sans-serif;
    }
  </style>
`;

export const getPdfFooter = () => {
  // Chrome already adds 15px of padding to the top/bottom of the page,
  // So we only need a 20px margin-bottom
  return `
    ${css}
    <div
      style="display: flex; justify-content: space-between; width: 100%; margin-left: 35px; margin-bottom: 20px; margin-right: 35px; align-items:center; color: #a6a6a5; font-size: 8px;">
      <div style="padding-top: 25px">
        <span class="pageNumber"></span> | Report Date: ${shortDateString(new Date())}
      </div>
    </div>
  `;
};

export const getPdfHeader = (titleText, bodyText) => {
  return `
  	  ${css}
  	  <div
  	    style="display: flex; justify-content: space-between; width: 100%; margin-left: 35px; margin-right: 35px; color: #a6a6a5; margin-top: 20px; font-size: 8px;"
  	  >
        <div style="font-size: 14px; color: black;">
          ${titleText}
        </div>
        ${bodyText}
  	  </div>
  	`;
};
